module.exports = __webpack_public_path__ + "static/media/DAI.42d0a1b9.png";